import tree from "../../../components/tree.vue";
import iTable from "../../../components/Table.vue";
import IPagination from "../../../components/pagination.vue";
import {
    domainName
} from "../../../utility/index"

export default {
    name: "DriverTrain",
    components: {
        tree,
        iTable,
        IPagination,
    },
    data() {
        return {
            isCollapse: false,
            stateArrow: true,
            isSearch: true,
            formInline: {
                trainTitle: '',
                driverExpires: [],
            },
            height: '550',
            list: [],
            option: {
                stripe: true,
                border: true,
                loading: false,
                highlightCurrentRow: false,
                mutiSelect: true,
                serialNumber: true,
            },
            columns: [{
                prop: "trainTitle",
                label: this.$t('DriverManagement.trainTitle'),
                align: "center",
                width: "160px"
            },
            {
                prop: "examEndTime",
                label: this.$t('DriverManagement.examEndTime'),
                align: "center",
                width: "220px"
            },
            {
                prop: "examDuration",
                label: this.$t('DriverManagement.examDuration'),
                align: "center",
                width: "120px"
            },
            {
                prop: "examQuestion",
                label: this.$t('DriverManagement.examQuestion'),
                align: "center",
                width: "160px",
                render: (h, params) => {
                    return h('el-tag', {
                        on: {
                            click: () => {
                                console.log(params)
                                this.dialogOperateFormVisible = true
                                this.OperateType = 'examQuestion'
                                this.OperateTitle = this.$t('DriverManagement.examQuestion')
                                this.isShow = false
                                this.isDisplay = false
                                this.AllColumns = this.topicColumns
                                this.trainNum = params.row.trainNum
                                this.getOperateList()
                            }
                        }
                    }, params.row.examQuestion)
                }
            },
            {
                prop: 'examDriverCount',
                label: this.$t('DriverManagement.examDriverCount'),
                align: 'center',
                width: "160px",
                render: (h, params) => {
                    return h('el-tag', {
                        on: {
                            click: () => {
                                console.log(params)
                                this.dialogOperateFormVisible = true
                                this.OperateType = 'examDriverCount'
                                this.OperateTitle = this.$t('DriverManagement.examDriverCount')
                                this.isShow = false
                                this.isDisplay = true
                                this.AllColumns = this.driverColumns
                                this.trainNum = params.row.trainNum
                                this.getOperateList()
                            }
                        }
                    }, params.row.examDriverCount)
                }
            },
            {
                prop: "examPassMark",
                label: this.$t('DriverManagement.examPassMark'),
                align: "center",
                width: "180px"
            },
            {
                prop: "examResult",
                label: this.$t('DriverManagement.examResult'),
                align: "center",
                width: "350px",
                render: (h, params) => {
                    return h('el-tag', {
                        on: {
                            click: () => {
                                console.log(params)
                                this.dialogOperateFormVisible = true
                                this.OperateType = 'examResult'
                                this.OperateTitle = this.$t('DriverManagement.result')
                                this.isShow = true
                                this.isDisplay = true
                                this.AllColumns = this.resultColumns
                                this.trainNum = params.row.trainNum
                                this.getOperateList()
                            }
                        }
                    }, params.row.examResult)
                }
            },
            ],
            operates: {
                width: 100,
                fixed: "right",
                list: [
                ],
            },
            currentPage: 1,
            pageSize: 10,
            total: 1,
            typeList: [],
            dialogFormVisible: false,
            formLabelWidth: '160px',
            diaTitle: '',
            btnType: '',
            rules: {
                trainTitle: [{
                    required: true,
                    message: this.$t('DriverManagement.form.trainTitle'),
                    trigger: 'blur'
                }],
                examEndTime: [{
                    required: true,
                    message: this.$t('DriverManagement.form.examEndTime'),
                    trigger: 'change'
                }],
                examDuration: [{
                    required: true,
                    message: this.$t('DriverManagement.form.examDuration'),
                    trigger: 'blur'
                }],
                examPassMark: [{
                    required: true,
                    message: this.$t('DriverManagement.form.examPassMark'),
                    trigger: 'blur'
                }],
                trainQuestionFile: [
                    { required: true, message: this.$t('DriverManagement.form.uploadExamQuestion'), trigger: 'blur' },
                ],
                trainDriverFile: [
                    { required: true, message: this.$t('DriverManagement.form.uploadExamDriver'), trigger: 'blur' },
                ],
            },
            form: {
                trainTitle: '',
                examEndTime: '',
                examDuration: '',
                examPassMark: '',
                trainQuestionFile: '',
                trainDriverFile: '',
            },
            selected: [],
            id: '',
            name: '',
            dialogBatchFormVisible: false,

            trainNum: '',
            dialogOperateFormVisible: false,
            OperateType: '',
            OperateTitle: '',
            formTable: {
                number: '',
                examState: '',
                examResult: ''
            },
            StateList: [
                {
                    value: null,
                    label: this.$t('common.all')
                },
                {
                    value: '0',
                    label: this.$t('DriverManagement.noExam')
                },
                {
                    value: '1',
                    label: this.$t('DriverManagement.exam')
                }
            ],
            ResultList: [
                {
                    value: null,
                    label: this.$t('common.all')
                },
                {
                    value: '0',
                    label: this.$t('DriverManagement.noPass')
                },
                {
                    value: '1',
                    label: this.$t('DriverManagement.pass')
                },
                {
                    value: '2',
                    label: this.$t('DriverManagement.misssExam')
                }
            ],
            isShow: true,
            isDisplay: true,
            authorizeList: [],
            authorizeHeight: '350px',
            AllColumns: [],
            driverColumns: [
                {
                    prop: "driverNum",
                    label: this.$t('DriverManagement.driverNum'),
                    align: "center",
                },
                {
                    prop: "driverName",
                    label: this.$t('DriverManagement.name'),
                    align: "center",
                },
            ],
            topicColumns: [
                {
                    prop: "examQuestion",
                    label: this.$t('DriverManagement.examQuestion'),
                    align: "center",
                },
                {
                    prop: "questionAnswerStr",
                    label: this.$t('DriverManagement.questionAnswerStr'),
                    align: "center",
                    width: "120px"
                },
            ],
            resultColumns: [
                {
                    prop: "driverNum",
                    label: this.$t('DriverManagement.driverNum'),
                    align: "center",
                    width: "120px"
                },
                {
                    prop: "driverName",
                    label: this.$t('DriverManagement.name'),
                    align: "center",
                },
                {
                    prop: "examStateStr",
                    label: this.$t('DriverManagement.examStateStr'),
                    align: "center",
                },
                {
                    prop: "driverExamTime",
                    label: this.$t('DriverManagement.driverExamTime'),
                    align: "center",
                },
                {
                    prop: "examResult",
                    label: this.$t('DriverManagement.examResult'),
                    align: "center",
                    render: (h, params) => {
                        return h('el-tag', {
                            props: {
                                type: params.row.examResult == null ? '' : params.row.examResult == 0 ? 'warning' : params.row.examResult == 1 ? 'success' : 'danger'
                            }
                        }, params.row.examResult == null ? '' : params.row.examResult == 0 ? this.$t('DriverManagement.noPass') : params.row.examResult == 1 ? this.$t('DriverManagement.pass') : this.$t('DriverManagement.misssExam'))
                    }
                },
            ],
            authorizeOperates: {
                width: 100,
                fixed: "right",
                list: [

                ],
            },
            authorizeOption: {
                stripe: true,
                border: true,
                loading: false,
                highlightCurrentRow: false,
                mutiSelect: false,
                serialNumber: true,
            },
            AuthorizeCurrentPage: 1,
            AuthorizePageSize: 10,
            AuthorizeTotal: 1,

            editDisabled: true,
            delDisabled: true,
            submitDisabled: true
        }
    },
    created() {

    },
    methods: {
        toggleSideBar() {
            this.isCollapse = !this.isCollapse
            this.$store.dispatch('menuTab/toggleSideBar', this.isCollapse)
        },
        changeArrow() {
            this.stateArrow = !this.stateArrow
        },
        initQuery(item) {
            this.id = item.id
            this.name = item.name
            if (this.$route.params.driverExpirationId) {
                this.formInline.state = this.$route.params.driverExpirationId
            }
            this.getAllDriver()
        },
        nodeClick(val) {
            this.id = val.label
            this.name = val.value
            this.getAllDriver()
        },
        getAllDriver() {
            let startTime = ''
            let endTime = ''
            if (this.formInline.driverExpires) {
                if (this.formInline.driverExpires.length > 0) {
                    startTime = this.formInline.driverExpires[0]
                    endTime = this.formInline.driverExpires[1]
                }
            }
            let param = {
                orgId: this.id,
                trainTitle: this.formInline.trainTitle,
                startTime: startTime,
                endTime: endTime,
                pageNum: this.currentPage,
                pageSize: this.pageSize,
            }
            this.$store.dispatch('DriverTrain/GET_GETTRAINLIST', param).then(res => {
                if (res) {
                    console.log(res)
                    if (res.data.code == 200) {
                        this.list = res.data.data.list
                        this.$refs.page.CommandTotal = res.data.data.total
                    }
                }
            }).catch(err => { })
        },
        onSearch() {
            this.$refs.page.CommandCurrentPage = 1
            this.currentPage = 1
            this.getAllDriver()
        },
        onClear() {
            this.formInline = {
                trainTitle: '',
                driverExpires: [],
            }
            this.getAllDriver()
        },

        uploadTopic(e) {
            let dom = document.getElementById('uploadTopic')
            let file = dom.files[0];
            console.log(file)
            this.form.trainQuestionFile = file
        },
        uploadDriver(e) {
            let dom = document.getElementById('uploadDriver')
            let file = dom.files[0];
            this.form.trainDriverFile = file
        },
        addDriver() {
            this.dialogFormVisible = true
            this.diaTitle = this.$t('common.btn.add')
            this.btnType = 'add'
            this.disabled = false
            this.$nextTick(() => {
                this.$refs.form.resetFields()
                this.form.trainQuestionFile = ''
                this.form.trainDriverFile = ''
                document.getElementById('uploadTopic').value = ''
                document.getElementById('uploadDriver').value = ''
            })
        },
        editDriver() {
            this.dialogFormVisible = true
            this.diaTitle = this.$t('common.btn.edit')
            this.btnType = 'edit'
            this.disabled = true
            this.$nextTick(() => {
                this.$refs.form.clearValidate()
                this.form.trainTitle = this.selected[0].trainTitle
                this.form.examDuration = this.selected[0].examDuration
                this.form.examEndTime = this.selected[0].examEndTime
                this.form.examPassMark = this.selected[0].examPassMark
                this.form.trainQuestionFile = ''
                this.form.trainDriverFile = ''
                document.getElementById('uploadTopic').value = ''
                document.getElementById('uploadDriver').value = ''
            })

        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    let formData = new FormData()
                    formData.append('orgId', this.id)
                    formData.append('trainTitle', this.form.trainTitle)
                    formData.append('examDuration', this.form.examDuration)
                    formData.append('examEndTime', this.form.examEndTime)
                    formData.append('examPassMark', this.form.examPassMark)
                    formData.append('trainDriverFile', this.form.trainDriverFile)
                    formData.append('trainQuestionFile', this.form.trainQuestionFile)
                    if (this.btnType == 'add') {
                        this.$store.dispatch('DriverTrain/GET_INSERTTRAIN', formData).then(res => {
                            if (res.data.code == 200) {
                                this.$message.success(this.$t('common.btn.addSuccess'))
                                this.dialogFormVisible = false;
                                this.getAllDriver();
                                this.closeDia();
                            } else {
                                this.$message.error(res.data.msg)
                            }

                        }).catch(err => { })
                    } else {
                        let formDataUpdate = new FormData()
                        formDataUpdate.append('trainNum', this.selected[0].trainNum)
                        formDataUpdate.append('trainTitle', this.form.trainTitle)
                        formDataUpdate.append('examDuration', this.form.examDuration)
                        formDataUpdate.append('examEndTime', this.form.examEndTime)
                        formDataUpdate.append('examPassMark', this.form.examPassMark)
                        formDataUpdate.append('trainDriverFile', this.form.trainDriverFile)
                        formDataUpdate.append('trainQuestionFile', this.form.trainQuestionFile)
                        this.$store.dispatch('DriverTrain/GET_UPDATETRAIN', formDataUpdate).then(res => {
                            if (res.data.code == 200) {
                                this.$message.success(this.$t('common.btn.editSuccess'))
                                this.dialogFormVisible = false;
                                this.getAllDriver();
                                this.closeDia();
                            } else {
                                this.$message.error(res.data.msg)
                            }

                        }).catch(err => { })
                    }



                } else {
                    return false;
                }
            });
        },

        cancle(formName) {
            this.dialogFormVisible = false;
            this.form = {
                trainTitle: '',
                examEndTime: '',
                examDuration: '',
                examPassMark: '',
                trainQuestionFile: '',
                trainDriverFile: '',
            }
        },
        closeDia() {
            this.form = {
                trainTitle: '',
                examEndTime: '',
                examDuration: '',
                examPassMark: '',
                trainQuestionFile: '',
                trainDriverFile: '',
            }
            this.dialogFormVisible = false;
        },
        deleteDriver() {
            this.$confirm(this.$t('common.btn.confirmDelete'), this.$t('common.btn.hint'), {
                cancelButtonText: this.$t('common.btn.cancel'),
                confirmButtonText: this.$t('common.btn.confirm'),
                type: 'warning'
            }).then(res => {
                let param = {
                    trainNum: this.selected[0].trainNum
                }
                this.$store.dispatch('DriverTrain/GET_DELETETRAIN', param).then(response => {
                    if (response.data.code == 200) {
                        this.getAllDriver()
                        this.$message.success(this.$t('common.btn.deleteSuccess'))
                    } else {
                        this.$message.error(response.data.msg)
                    }
                }).catch(error => { })
            }).catch(err => {

            })
        },
        submitBtn() {
            this.$confirm(this.$t('common.btn.confirmSubmit'), this.$t('common.btn.hint'), {
                cancelButtonText: this.$t('common.btn.cancel'),
                confirmButtonText: this.$t('common.btn.confirm'),
                type: 'warning'
            }).then(res => {
                let param = {
                    trainNum: this.selected[0].trainNum
                }
                this.$store.dispatch('DriverTrain/GET_UPDATEFIXED', param).then(response => {
                    if (response.data.code == 200) {
                        this.getAllDriver()
                        this.$message.success(this.$t('common.btn.submitSuccess'))
                    } else {
                        this.$message.error(response.data.msg)
                    }
                }).catch(error => { })
            }).catch(err => {

            })
        },
        DriveImport() {
            if (domainName) {
                if (domainName.split(':')[0] !== 'localhost') {
                    let url = `https://${domainName}/v1/exportTemplate/exportTrainDriverTemplate`
                    location.href = url
                } else {
                    let host = 'localhost:8080'
                    let url = `https://${host}/v1/exportTemplate/exportTrainDriverTemplate`
                    location.href = url
                }
            }
        },
        topicImport() {
            if (domainName) {
                if (domainName.split(':')[0] !== 'localhost') {
                    let url = `https://${domainName}/v1/exportTemplate/exportTrainQuestionTemplate`
                    location.href = url
                } else {
                    let host = 'localhost:8080'
                    let url = `https://${host}/v1/exportTemplate/exportTrainQuestionTemplate`
                    location.href = url
                }
            }
        },

        getOperateList() {
            if (this.OperateType == 'examDriverCount') {
                let param = {
                    trainNum: this.trainNum,
                    number: this.formTable.number,
                    pageNum: this.AuthorizeCurrentPage,
                    pageSize: this.AuthorizePageSize,
                }
                this.$store.dispatch('DriverTrain/GET_GETEXAMDRIVER', param).then(res => {
                    if (res) {
                        if (res.data.code == 200) {
                            this.authorizeList = res.data.data.list
                            this.$refs.AuthorizePage.CommandTotal = res.data.data.total
                        }
                    }
                }).catch(err => { })
            } else if (this.OperateType == 'examResult') {
                let param = {
                    trainNum: this.trainNum,
                    number: this.formTable.number,
                    examState: this.formTable.examState,
                    examResult: this.formTable.examResult,
                    pageNum: this.AuthorizeCurrentPage,
                    pageSize: this.AuthorizePageSize,
                }
                this.$store.dispatch('DriverTrain/GET_GETEXAMDRIVER', param).then(res => {
                    if (res) {
                        if (res.data.code == 200) {
                            this.authorizeList = res.data.data.list
                            this.$refs.AuthorizePage.CommandTotal = res.data.data.total
                        }
                    }
                }).catch(err => { })
            } else {
                let param = {
                    trainNum: this.trainNum,
                }
                this.$store.dispatch('DriverTrain/GET_GETEXAMQUESTION', param).then(res => {
                    if (res) {
                        if (res.data.code == 200) {
                            this.authorizeList = res.data.data
                        }
                    }
                }).catch(err => { })
            }
        },
        closeOperateDia() {
            this.dialogOperateFormVisible = false
        },
        Search() {
            this.$refs.AuthorizePage.CommandCurrentPage = 1
            this.AuthorizeCurrentPage = 1
            this.getOperateList()
        },
        Clear() {
            this.formTable = {
                number: '',
                examState: '',
                examResult: ''
            }
            this.getOperateList()
        },
        changeAuthorizeSize(item) {
            this.AuthorizePageSize = item.pageSize
            this.AuthorizeCurrentPage = item.pageNum
            this.getOperateList();
        },

        down() {
            if (this.OperateType == 'examDriverCount') {
                if (domainName) {
                    if (domainName.split(':')[0] !== 'localhost') {
                        let url = `https://${domainName}/v1/getExportExcel/exportDriverExam?trainNum=${this.trainNum}&number=${this.formTable.number}`
                        location.href = url
                    } else {
                        let host = 'localhost:8080'
                        let url = `https://${host}/v1/getExportExcel/exportDriverExam?trainNum=${this.trainNum}&number=${this.formTable.number}`
                        location.href = url
                    }
                }
            } else if (this.OperateType == 'examResult') {
                if (domainName) {
                    if (domainName.split(':')[0] !== 'localhost') {
                        let url = `https://${domainName}/v1/getExportExcel/exportExamDriver?trainNum=${this.trainNum}&number=${this.formTable.number}&examState=${this.formTable.examState}&examResult=${this.formTable.examResult}`
                        location.href = url
                    } else {
                        let host = 'localhost:8080'
                        let url = `https://${host}/v1/getExportExcel/exportExamDriver?trainNum=${this.trainNum}&number=${this.formTable.number}&examState=${this.formTable.examState}&examResult=${this.formTable.examResult}`
                        location.href = url
                    }
                }
            } else {
                if (domainName) {
                    if (domainName.split(':')[0] !== 'localhost') {
                        let url = `https://${domainName}/v1/getExportExcel/exportExamQuestion?trainNum=${this.trainNum}`
                        location.href = url
                    } else {
                        let host = 'localhost:8080'
                        let url = `https://${host}/v1/getExportExcel/exportExamQuestion?trainNum=${this.trainNum}`
                        location.href = url
                    }
                }
            }
        },

        handleSelectionChange(val) {
            console.log(val)
            this.selected = val
            if (this.selected.length == 1) {
                if (this.selected[0].fixed == 0) {
                    this.editDisabled = false
                    this.delDisabled = false
                    this.submitDisabled = false
                } else {
                    this.editDisabled = true
                    this.delDisabled = true
                    this.submitDisabled = true
                }
            } else {
                this.editDisabled = true
                this.delDisabled = true
                this.submitDisabled = true
            }

        },
        changeSize(item) {
            this.pageSize = item.pageSize
            this.currentPage = item.pageNum
            this.getAllDriver();
        },
        onResize: function (x, y, width, height) {
            let box = document.getElementById("leftBox");
            box.style.width = width + "px";
        },


    }
}